// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Chrome, Safari, Edge, Opera */
.NumberInput-module__Input__hxbmK::-webkit-outer-spin-button,
.NumberInput-module__Input__hxbmK::-webkit-inner-spin-button {
    margin: 0;
    appearance: none;
}
/* Firefox */
/* stylelint-disable-next-line selector-max-specificity -- DS component */
.NumberInput-module__Input__hxbmK[type='number'] {
    appearance: textfield;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Input": `NumberInput-module__Input__hxbmK`
};
export default ___CSS_LOADER_EXPORT___;
